// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1K-Eu","border":"style_border__16fBf","header":"style_header__2Un3j","btn":"style_btn__3E57w","content":"style_content__1sgOV","normal":"style_normal__3C31M"};